import { BuildContext, ExportOptions, ExportPayloadSection } from '../../types';
import appendXmlRows from './appendXmlRows';
import escapeXml from './escapeXml';
import resolveXmlEncodingName from './resolveXmlEncodingName';

const buildXmlContent = async (
  sections: ExportPayloadSection[],
  options: ExportOptions,
  context: BuildContext
): Promise<string> => {
  const isSingleRootExport = sections.length === 1;
  const rootSection = sections[0];
  const rootAttributes =
    isSingleRootExport && rootSection
      ? ` table="${escapeXml(rootSection.id)}" name="${escapeXml(
          rootSection.label
        )}"`
      : '';
  const lines = [
    `<?xml version="1.0" encoding="${resolveXmlEncodingName(
      options.encoding
    )}"?>`,
    `<export${rootAttributes}>`,
  ];

  for (const section of sections) {
    if (isSingleRootExport) {
      await appendXmlRows(
        lines,
        section.rows,
        section.columns,
        options,
        '  ',
        context,
        section.childSections,
        section.masterIdItem
      );
      continue;
    }

    lines.push(
      `  <section id="${escapeXml(section.id)}" label="${escapeXml(
        section.label
      )}">`
    );
    await appendXmlRows(
      lines,
      section.rows,
      section.columns,
      options,
      '    ',
      context
    );
    lines.push('  </section>');
  }

  lines.push('</export>');

  return lines.join('\n');
};

export default buildXmlContent;
